<a
  class="link"
  data-cy="list-element">
  <div
    [ngClass]="{'element--with-select': selectable}"
    class="element">
    <div
      (click)="toggle(); $event.stopPropagation()"
      *ngIf="selectable"
      class="element__select select-element">
      <div
        [ngClass]="selected ? 'checkbox--selected' : 'checkbox--not-selected'"
        class="checkbox checkbox--selected">
        <mat-icon class="check-icon">check</mat-icon>
      </div>
    </div>

    <div
      [ngClass]="{'store--small' : small}"
      class="store">

      <div class="store__number">
        {{number}}
      </div>

      <div class="store__info">
        <div class="store__title">
          <div
            *ngIf="name"
            [matTooltip]="name"
            class="store__name"
            data-cy="list-element.name">
            {{name}}
          </div>

          <div
            *ngIf="subName && (subName !== name)"
            class="store__subname">
            {{subName}}
          </div>
        </div>

        <div
          *ngIf="label"
          [matTooltip]="label"
          class="store__label">
          {{label}}
        </div>
      </div>

      <span class="separator"></span>

      <div class="total">
        <div class="total__header">
          <div class="total__label">
            <span>{{totalLabel}}</span>
            <coa-icon-tooltip *ngIf="totalTooltip" [tooltip]="totalTooltip | translate"
                              class="total__tooltip"></coa-icon-tooltip>
          </div>

          <span
            class="total__value"
            data-cy="list-element.total-value">
            {{(totalValue || 0) + '%'}}
          </span>
        </div>

        <coa-progress-bar [value]="totalValue || 0" class="total__progress-bar"></coa-progress-bar>
      </div>

      <div class="chart">
        <coa-date-range-label [dateRange]="chartLabel" class="chart__label"></coa-date-range-label>
        <coa-simple-line-chart [chartData]="chartValue" class="chart__value"></coa-simple-line-chart>
      </div>

      <div class="percentage-change">
        <span class="percentage-change__label">{{percentageChangeLabel}}</span>
        <coa-percentage-change
          [value]="percentageChangeValue"
          class="percentage-change__value">
        </coa-percentage-change>
      </div>

      <ng-container *ngIf="paymentsEnabledToggle$ | async">
        <span class="separator"></span>

        <div class="percentage">
          <span class="percentage__label">
            {{percentage?.label}}
          </span>
          <span class="percentage__value">{{percentage?.value + ' %'}}</span>
        </div>
      </ng-container>
    </div>
  </div>
</a>
